// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Playfair', 'Playfair Fallback'","fontStyle":"normal"},"className":"__className_f5f6e6","variable":"__variable_f5f6e6"};